import { render, staticRenderFns } from "./CMobileScroll.vue?vue&type=template&id=69f6e408&scoped=true"
import script from "./CMobileScroll.vue?vue&type=script&lang=js"
export * from "./CMobileScroll.vue?vue&type=script&lang=js"
import style0 from "./CMobileScroll.vue?vue&type=style&index=0&id=69f6e408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f6e408",
  null
  
)

export default component.exports